export default "<div class=\"checkmark\"></div>\n<ng-content></ng-content>\n";